import { Component, Input, OnInit } from '@angular/core';
import { AcontoClientView } from '../models';

@Component({
    selector: 'app-interim-invoicing-list',
    templateUrl: './interim-invoicing-list.component.html',
    standalone: false
})
export class InterimInvoicingListComponent implements OnInit {

    @Input() acontoClients: AcontoClientView[];
    @Input() acontoDate: Date;

    constructor() { }

    ngOnInit(): void {
    }

    trackByFnr(_: number, acontoClient: AcontoClientView) {
        return acontoClient.kid;
    }
}
